import { Directive, Input, OnInit, TemplateRef, ViewContainerRef, inject } from "@angular/core";
import { tap } from "rxjs/operators";
import { FeatureConfig, FeatureService } from "./feature.service";

@Directive({ selector: "[featureEnabled]" })
export class FeatureEnabledDirective implements OnInit {
  private templateRef = inject<TemplateRef<any>>(TemplateRef);
  private viewContainerRef = inject(ViewContainerRef);
  private featureService = inject(FeatureService);

  @Input() set featureEnabled(val: string) {
    if (val) {
      this._featureEnabled = val;
    }
  }

  private _featureEnabled = "";

  ngOnInit() {
    this.featureService
      .feature$(this._featureEnabled)
      .pipe(
        tap((data: FeatureConfig | null) => {
          if (data !== null && data["enabled"]) {
            this.viewContainerRef.createEmbeddedView(this.templateRef, {
              $implicit: data
            });
          } else {
            this.viewContainerRef.clear();
          }
        })
      )
      .subscribe();
  }
}
